var _rect, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDotsMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 14,
    height: 24,
    rx: 4,
    transform: "rotate(-180 14 24)",
    fill: "#EDF1F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 7,
    cy: 18,
    r: 2,
    transform: "rotate(-180 7 18)",
    fill: "#0E1C1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 7,
    cy: 12,
    r: 2,
    transform: "rotate(-180 7 12)",
    fill: "#0E1C1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 7,
    cy: 6,
    r: 2,
    transform: "rotate(-180 7 6)",
    fill: "#0E1C1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsMenu);
export default __webpack_public_path__ + "static/media/three-dots-menu.a63ca2ca22bbbad8e1ac5497dc99e764.svg";
export { ForwardRef as ReactComponent };